const getResourceBaseUrl = (env: string) => {
  return {
    local: "https://stg.hobbyresources.com",
    stg: "https://stg.hobbyresources.com",
    prd: "https://www.hobbyresources.com",
  }[env];
};

export default getResourceBaseUrl;
